module.exports = __webpack_public_path__ + "img/Icon_Edit.25ea97f4.svg";